export const CURRENCY_TYPE_FACTOR = {
  0: 1,
  1: 10,
  2: 100,
  6: 25,
  7: 0.30,
  // 8: 0.35
};
